import Vue from 'vue'
import VueCookies from 'vue-cookies'
import API from '@/api/index'
import { envTypeData } from '@/utils/public'
Vue.use(VueCookies)
/*
envTypeData:
  noneEnv: 'noneEnv', // 两个都没
  master: 'master', // 正式环境
  test: 'test', // 集成环境
  allEnv: 'allEnv', // 两个都有
  */

const state = {
  defaultActiveIndex: '0',
  show: 'vuex成功',
  username: VueCookies.get('username') || '',
  phone: VueCookies.get('phone') || '',
  userLoginInfo: VueCookies.get('userLoginInfo') || {},
  envType: VueCookies.get('envType') || '',
  currentClientId: VueCookies.get('currentClientId') || '',
  defaultEnvOfTwo: VueCookies.get('defaultEnvOfTwo') || 'master',
  baseInfo: JSON.parse(sessionStorage.getItem('baseInfo')),
  paneActiveName: sessionStorage.getItem('paneActiveName') || '0',
  envApi: VueCookies.get('envApi'),
}
const mutations = {
  SET_ActiveIndex: (state, defaultActiveIndex) => {
    // console.log('传入的路径', defaultActiveIndex)
    if (defaultActiveIndex === '/agent/customerDetail') {
      state.defaultActiveIndex = '/agent/customerManagement'
    } else if (defaultActiveIndex === '/followUp/admin/userManage/roleDetail') {
      state.defaultActiveIndex = '/followUp/admin/userManage/roleManage'
    } else {
      state.defaultActiveIndex = defaultActiveIndex
    }
  },
  CHANGE_SETTING: (state, { key, value }) => {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = value
      VueCookies.set(key, value)
    }
  },
  SET_BASEINFO: (state, baseInfo) => {
    state.baseInfo = baseInfo
  },
  SET_PaneActiveName: (state, paneActiveName) => {
    state.paneActiveName = paneActiveName
    sessionStorage.setItem('paneActiveName', paneActiveName)
  },
  SET_ENVAPI: (state, { key, value }) => {
    state.envApi = value
    // sessionStorage.setItem('envApi', envApi)
    VueCookies.set(key, value)
  },
  SET_PHONE: (state) => {
    state.phone = VueCookies.get('phone')
  }
}
const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  setBaseInfo({ commit }, baseInfo) {
    commit('SET_BASEINFO', baseInfo)
    sessionStorage.setItem('baseInfo', JSON.stringify(baseInfo))
  },
  defaultEnv({ commit, state }, EnvOfTwo) {
    // 环境初始化
    console.log('环境初始化1111')
    let envType = ''
    let defaultEnvOfTwo = 'master' //默认为正式
    const tmpUserLoginInfo = state.userLoginInfo
    let envApi = tmpUserLoginInfo?.type === 1 ? 'testopenapi' : 'openapi'
    let currentClientId = '' // 定义对应环境下的clientId
    if (tmpUserLoginInfo?.type === 1) {
      if (!tmpUserLoginInfo.clientId && !tmpUserLoginInfo.testClientId) {
        // 两个环境都没有厂商信息
        envType = envTypeData.noneEnv
        currentClientId = ''
        defaultEnvOfTwo = null
      } else if (tmpUserLoginInfo.clientId && tmpUserLoginInfo.testClientId) {
        envType = envTypeData.allEnv
        // 两个环境都有，默认展示正式环境 --defaultEnvOfTwo表示两个环境下展示哪一个环境
        if (EnvOfTwo && EnvOfTwo === 'test') {
          defaultEnvOfTwo = EnvOfTwo
          currentClientId = tmpUserLoginInfo.testClientId
        } else {
          defaultEnvOfTwo = 'master'
          currentClientId = tmpUserLoginInfo.clientId
          envApi='openapi'
        }
      } else if (tmpUserLoginInfo.clientId) {
        // 只有正式环境的厂商
        envType = envTypeData.master
        currentClientId = tmpUserLoginInfo.clientId
        defaultEnvOfTwo = envTypeData.master
        envApi='openapi'
      } else {
        envType = envTypeData.test
        currentClientId = tmpUserLoginInfo.testClientId
        defaultEnvOfTwo = envTypeData.test
      }
    }
    console.log('环境初始化的envApi',envApi)
    commit('CHANGE_SETTING', {
      key: 'envType',
      value: envType,
    })
    commit('CHANGE_SETTING', {
      key: 'currentClientId',
      value: currentClientId,
    })
    commit('CHANGE_SETTING', {
      key: 'defaultEnvOfTwo',
      value: defaultEnvOfTwo,
    })
    commit('SET_ENVAPI', {
      key: 'envApi',
      value: envApi,
    })
  },
  // 正式环境切集成环境，需要调用此接口，刷新token
  synLogin({ dispatch }) {
    return new Promise((resolve, reject) => {
      // 正式环境切 集成环境，如果登录信息在cookie中不存在，跳转到登录
      const tmpUserLoginInfo = VueCookies.get('userLoginInfo')
      if (!Object.keys(tmpUserLoginInfo).length) {
        window.location.href = '../homeList/homePage.html'
      }
      const { testClientId, clientId } = tmpUserLoginInfo
      const tmpUniqueid = tmpUserLoginInfo.uniqueid
      const firmParams = {
        accountId: tmpUniqueid, // 账号ID
        testClientId,
        clientId,
      }
      API.synLogin_test(firmParams)
        // eslint-disable-next-line consistent-return
        .then((result) => {
          if (!API.ApiRequest(result)) {
            return false
          }
          // dispatch('defaultEnv','test')
          resolve('100')
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
